import React, { useContext, useEffect, useState } from 'react';

// Libarary
import Carousel from '@brainhubeu/react-carousel';
import { useMediaQuery } from 'react-responsive';

// interface
import { IConfirmModalProps, IModuleTile, IOnboardingModalProps } from '../../../interfaces/interfaces';

// Source
import OnboardingItemModule from './OnboardingItemModule';
import keyboardTriggerBasic from '../../../utils/keyboard-trigger';
import UserTileContext from '../../../contexts/userTilesContext';
import { saveConfiguration, loadOnboarding } from '../../../utils/data';

export default function OnboardingModal(props: IConfirmModalProps): JSX.Element {
  const { onAbort } = props;
  const userTiles = useContext(UserTileContext);
  const [onboardingData, setOnboardingData] = useState<IOnboardingModalProps>();

  // will update later, Text will come later from config
  const onboardingDataMock = {
    title: 'Willkommen in Ihrem persönlichen Partner Cockpit',
    header: 'Wie möchten Sie starten?',
    overlayItems: [
      {
        id: '1',
        headline: 'Lernen Sie Ihr  Cockpit kennen',
        textContent: 'lorem ipsum1',
        linkText: 'Video starten',
        linkHref: 'https://www.kfw.de/kfw.de.html',
        linkTarget: '_blank',
        linkClass: 'link link--button button--small',
        linkTextClass: 'link__name link__name-inner link__name-text',
        linkIconClass: 'ic-videoRound',
        iconUrl: '',
      },
      {
        id: '2',
        headline: 'Konfigurieren Sie Ihr Cockpit',
        textContent: 'lorem ipsum2',
        linkText: 'Cockpit personalisieren',
        linkHref: '#',
        linkTarget: '',
        linkClass: 'link link--button button--small',
        linkTextClass: 'link__name link__name-inner link__name-text',
        linkIconClass: 'ic-arrowRight',
        iconUrl: '',
      },
      {
        id: '3',
        headline: 'Starten Sie direkt mit der Arbeit',
        textContent: 'Dlorem ipsum3',
        linkText: 'Direkt zum Cockpit',
        // linkHref: '',
        // linkTarget: '',
        linkClass: 'link link--button button--small',
        linkTextClass: 'link__name link__name-inner link__name-text',
        linkIconClass: 'ic-arrowRight',
        iconUrl: '',
      },
    ],
  };

  useEffect(() => {
    // eslint-disable-next-line
    // @ts-ignore
    document.dispatchEvent(new CustomEvent('application.reinit', ['media-overlay']));
  }, [onboardingData]);

  useEffect(() => {
    setOnboardingData(onboardingDataMock);
    loadOnboarding().then((data) => {
      data.overlayItems = data.overlayItems.map((x) => {
        const mockData = onboardingDataMock.overlayItems.find((m) => m.id === x.id);
        return { ...mockData, ...x };
      });
      setOnboardingData(data);
    });
  }, []);

  const onAbortClick = () => {
    // close modal
    onAbort();
    const updatedSettings = { ...userTiles.settings, didFinishOnboarding: true };
    userTiles.setSettings(updatedSettings);
    saveConfiguration(userTiles.tiles as IModuleTile[], updatedSettings);
  };
  const isMobile = useMediaQuery({ query: '(max-width: 600px)' });

  return (
    <>
      <div className="modal onboarding-modal" role="dialog">
        <div className="modal-inner l-container">
          <a
            role="button"
            className="modal-closer"
            onClick={onAbortClick}
            onKeyDown={(e) => {
              keyboardTriggerBasic(e, onAbortClick);
            }}
            tabIndex={0}
          >
            <span className="ic-close" />
          </a>

          <div className="modal-inner-content">
            <div className="overlay-header">
              <h2 className="hl-2">{onboardingData?.title}</h2>
            </div>

            <h3 className="hl-3">{onboardingData?.header}</h3>
            {isMobile ? (
              <Carousel plugins={['arrows']}>
                {onboardingData?.overlayItems?.map((o) => {
                  return (
                    <div className="overlay-mobile" key={o.id}>
                      <span className="overlay-id">{o.id}/3</span>
                      <OnboardingItemModule
                        id={o.id}
                        headline={o.headline}
                        textContent={o.textContent}
                        linkText={o.linkText}
                        linkHref={o.linkHref}
                        linkClass={o.linkClass}
                        linkTarget={o.linkTarget}
                        linkTextClass={o.linkTextClass}
                        linkIconClass={o.linkIconClass}
                        dataAttributes={o.dataAttributes}
                        iconUrl={o.iconUrl}
                        closeOverlay={onAbortClick}
                      />
                    </div>
                  );
                })}
              </Carousel>
            ) : (
              // OnboardingItemModule Desktop without slider
              <div className="item-list">
                {onboardingData?.overlayItems?.map((o) => {
                  return (
                    <div className="overlay-desktop" key={o.id}>
                      <OnboardingItemModule
                        id={o.id}
                        headline={o.headline}
                        textContent={o.textContent}
                        linkText={o.linkText}
                        linkHref={o.linkHref}
                        linkClass={o.linkClass}
                        linkTarget={o.linkTarget}
                        linkTextClass={o.linkTextClass}
                        linkIconClass={o.linkIconClass}
                        dataAttributes={o.dataAttributes}
                        iconUrl={o.iconUrl}
                        closeOverlay={onAbortClick}
                      />
                    </div>
                  );
                })}
              </div>
            )}
          </div>
        </div>
      </div>
    </>
  );
}
